<template>
  <div
    class="rounded border border-grey-90 overflow-hidden"
    :class="bgColorClass"
  >
    <slot
      v-if="src || $slots.header"
      name="header"
    >
      <img
        :src="src"
        alt="Image"
        class="block w-full"
      >
    </slot>

    <slot />
  </div>
</template>

<script>

export default {
  props: {
    src: {
      type: String
    },
    bgColorClass: {
      type: String,
      default: 'bg-white'
    }
  }
}
</script>
